import { render, staticRenderFns } from "./MyClients.vue?vue&type=template&id=517ac01c&"
import script from "./MyClients.vue?vue&type=script&lang=js&"
export * from "./MyClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('517ac01c')) {
      api.createRecord('517ac01c', component.options)
    } else {
      api.reload('517ac01c', component.options)
    }
    module.hot.accept("./MyClients.vue?vue&type=template&id=517ac01c&", function () {
      api.rerender('517ac01c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MyClients.vue"
export default component.exports